export const SETS_VALUES = {
  ALIZE: {
    icon: 'fa-kit fa-custom fa-tbf',
    background:
      'https://altered-cms-prod-eu.s3.eu-west-3.amazonaws.com/wp-content/uploads/sites/2/2025/01/03132936/altered-product-page-trial-by-frost-header-cards.jpg',
  },
  BISE: {
    icon: 'fa-kit fa-custom fa-wfm',
    background:
      'https://altered-cms-prod-eu.s3.eu-west-3.amazonaws.com/wp-content/uploads/sites/2/2025/05/12145702/altered-wfm-product-cards.jpg',
  },
  CORE: {
    icon: 'fa-kit fa-fak fa-ext-coreset',
    background:
      'https://altered-cms-prod-eu.s3.eu-west-3.amazonaws.com/wp-content/uploads/sites/2/2024/04/29124052/altered_cards-sets_beyond-the-gates.jpg',
  },
  COREKS: {
    icon: 'fa-kit fa-fak fa-ks-set-icon',
    background:
      'https://altered-cms-prod-eu.s3.eu-west-3.amazonaws.com/wp-content/uploads/sites/2/2024/07/18014109/altered_set_bg_ks.jpg',
  },
  CYCLONE: {
    icon: 'fa-kit fa-sky',
    background:
      'https://altered-cms-prod-eu.s3.eu-west-3.amazonaws.com/wp-content/uploads/sites/3/2025/07/22093723/KA-Skybound-Odyssey-NOLOGO-RGB-1.jpg',
  },
};
